import React from "react";
import { EditionRecord, PrintRecord, BookRecord } from "../../BlakeData/Types";
import { EditionMicropalette } from "./EditionMicropalette";

import ReactSlider from "react-slider";
import { EditionHoverBox } from "./EditionHoverBox";
import { ActiveIndex, emptyActiveIndex } from "../Types";
import { Dimensions } from "../Dimensions";
import { API } from "../../BlakeData";

interface PseudoEditionProps {
    edition: EditionRecord,
    activeIndex: ActiveIndex;
    setActiveIndex: (activeIndex: ActiveIndex) => void
    padding: number,
    paletteWidth: number,
    paletteHeight: number,
    hoverItemWidth: number,
    groupIndex: number;
    editionIndex: number;
    dimensions: Dimensions;
    groupVisible: boolean;

    allPrints: Array<PrintRecord>;
    start: number;
    stop: number;

    displayYear: boolean;
}

interface PseudoEditionState {
    // prints: Array<PrintRecord> | null;
    visible: boolean;
    segmentIndex: number;
    book?: BookRecord;
}

export default class EditionView extends React.Component<PseudoEditionProps, {}>{

    state: PseudoEditionState;
    interactive: boolean = false;

    static defaultProps = {
        hoverItemWidth: 120,
        // padding: 2,
        // paletteWidth: 10,
        paletteHeight: 100
    }



    constructor(props: PseudoEditionProps) {
        super(props);

        this.state = {
            visible: true,
            // selectedItemIndex: 0,
            // prints: null,
            segmentIndex: 0

            // prints: []

        }

        // this.setActiveIndex = this.setActiveIndex.bind(this);
        // this.editionIsActive = this.editionIsActive.bind(this);
        this.renderPalette = this.renderPalette.bind(this);
        this.setValue = this.setValue.bind(this);
        this.getValue = this.getValue.bind(this);
        this.clearActiveIndex = this.clearActiveIndex.bind(this);

        API.getBook(this.props.edition.bookID).then((book: BookRecord) => {
            this.setState({ book });
        })

        // API.getEditionPrints(this.props.edition).then((prints: Array<PrintRecord>) => { this.setState({ prints }) })
    }

    clearActiveIndex() {
        this.props.setActiveIndex(emptyActiveIndex);
    }

    /**
     * Render the edition's micropalette, or a placeholder object
     */
    renderPalette(prints: Array<PrintRecord>, paletteID: string) {

        const height = this.props.paletteHeight;
        const width = (this.props.paletteWidth + this.props.padding) * (prints || []).length;

        const placeholderClass = this.state.visible ? "visible" : "invisible";

        return (
            <div
                style={{
                    boxSizing: "border-box",
                    height: `${height}px`,
                    width: `${width}px`
                }}
                className={"placeholder " + placeholderClass}>
                {this.props.groupVisible
                    ?
                    <EditionMicropalette
                        visible={this.props.groupVisible}
                        maxWidth={this.props.dimensions.width}
                        key={paletteID}
                        // edition={this.props.edition}
                        paletteID={paletteID}
                        prints={prints}
                        title={`Copy ${this.props.edition.archiveCopyID}`}
                    />
                    :
                    (null)
                }
            </div>
        )
    }

    setValue(idx: number | number[] | null | undefined) {
        // if (!this.interactive) { return }
        if (typeof idx !== "number") { return }
        const { groupIndex, editionIndex } = this.props;
        this.props.setActiveIndex({
            groupIndex,
            editionIndex,
            printIndex: idx
        });
        this.interactive = false;
    };

    getValue(): number {
        return this.props.activeIndex.printIndex - this.props.start;
    }

    render() {


        const { allPrints, start, stop } = this.props;
        const { paletteWidth, padding, paletteHeight: height } = this.props;

        const prints = allPrints.slice(start, stop)
        const count = prints.length || 0;
        const width = ((count * (paletteWidth + padding))) - padding;
        const paletteID = `${this.props.edition.id}-${start}-${stop}`

        // const isActive = this.editionIsActive()
        const isActive = (this.props.activeIndex.groupIndex === this.props.groupIndex)
            && (this.props.activeIndex.editionIndex === this.props.editionIndex)
            && (this.props.activeIndex.printIndex >= start && this.props.activeIndex.printIndex < stop)

        // let offset = 0;
        // let hoverItemWidth = 100;
        let hoverBox = (null);

        if (isActive) {

            let { printIndex } = this.props.activeIndex;


            printIndex = printIndex - start;
            // const currentPrint = prints[printIndex];
            const currentPrint = allPrints[this.props.activeIndex.printIndex]


            // const currentPrint = this.props.activeEdition.edition.prints[this.props.activeEdition.selectedItemIndex];
            hoverBox = <EditionHoverBox
                clearActiveIndex={this.clearActiveIndex}
                totalWidth={width}
                hoverItemWidth={this.props.hoverItemWidth}
                selectedItemIndex={printIndex}
                paletteWidth={paletteWidth}
                padding={padding}
                print={currentPrint}
            />
        }

        if (!this.state.visible) {

            return (null)
        }

        /**
         * calculate the index value based on an x coordinate.
         * Should return none if it's a gutter location
         */
        const getIndexValue = (x: number) => {

            const closestIdx = Math.floor(x / (paletteWidth + padding));
            // TODO - return null of it's a gutter
            return this.props.start + closestIdx;

        }

        var bookTitle = this.state.book ? this.state.book.title : this.props.edition.bookID.toUpperCase()

        // TODO - This is a quick hack, but we should add a field for shorter titles
        //        in the data to make this more re-usable
        const shortTitles:{[idx:string]:string} = {
            "America a Prophecy":"America",
            "Europe a Prophecy":"Europe",
            "Jerusalem The Emanation of The Giant Albion": "Jerusalem",
            "Milton a Poem":"Milton",
            "Songs of Innocence":"Innocence",
            "Songs of Innocence and of Experience": "Innocence & Experience",

            "The Book of Ahania":"Ahania",
            "The Book of Los":"Book of Los",
            "The Book of Thel":"Thel",
            "The First Book of Urizen":"Urizen",
            "The Marriage of Heaven and Hell":"Marriage",
            "The Song of Los":"Song of Los",
            "Visions of the Daughters of Albion":"Visions"

        }

        if (bookTitle in shortTitles){
            bookTitle = shortTitles[bookTitle]
            // console.log(`new booktitle ${bookTitle}`)
        }

        var copyID = this.props.edition.archiveCopyID.toUpperCase();
        if (copyID.toUpperCase() === "A-PROOF"){
            copyID = "A*"
        }

        return (

            <div className={`Edition ${isActive ? 'active' : 'inactive'}`}>
                <h6 className="edition-title">
                    {bookTitle}{" "}
                    {copyID}
                    {(start > 0) && (stop - start > 20) ? " (continued)" : (null)}</h6>
                <div
                    style={{
                        width: `${width}px`,
                        // height: `${(height + 20)}px`,
                        height: `${(height)}px`,
                        position: "relative"
                    }}
                >

                    <div
                        className={`track-container`}
                        style={{
                            paddingRight: "2px",
                            position: "absolute",
                            top: "0px",
                            bottom: "0px",
                            left: "0px",
                            right: "0px"
                        }}
                        onMouseMove={(evt) => {
                            const x = evt.nativeEvent.offsetX,
                                newIdx = getIndexValue(x);
                            this.setValue(newIdx);
                        }}
                    // onMouseOut={(evt) => {
                    //     this.clearActiveIndex();
                    // }}

                    >

                        {count && this.state.visible ?
                            <ReactSlider
                                className={"blake-slider-horizontal " + width + " " + count}
                                min={start}
                                max={stop - 1}
                                defaultValue={this.props.activeIndex.printIndex - start || start}
                                // value={this.props.activeIndex.printIndex - start}
                                value={this.props.activeIndex.printIndex}
                                onSliderClick={this.setValue}
                                onChange={this.setValue}
                            ></ReactSlider> : (null)}
                    </div>

                    {this.renderPalette(prints, paletteID)}

                    <div>
                        {hoverBox}
                    </div>


                </div>
            </div >
            //  </VisibilitySensor >
        )
    }
}